import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Internal\Me\AccountController::__invoke
* @see app/Http/Controllers/Api/Internal/Me/AccountController.php:18
* @route '/internal-api/me/accounts'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/internal-api/me/accounts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Internal\Me\AccountController::__invoke
* @see app/Http/Controllers/Api/Internal/Me/AccountController.php:18
* @route '/internal-api/me/accounts'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\Me\AccountController::__invoke
* @see app/Http/Controllers/Api/Internal/Me/AccountController.php:18
* @route '/internal-api/me/accounts'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Internal\Me\AccountController::__invoke
* @see app/Http/Controllers/Api/Internal/Me/AccountController.php:18
* @route '/internal-api/me/accounts'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

const accounts = {
    index: Object.assign(index, index),
}

export default accounts